import React from 'react';
import { UnderConstruction } from '@core/pages';
import { navItems } from '../navigation';

const Inventory: React.FC = () => {
  return <UnderConstruction navItems={navItems} path="/inventory" />;
};

export default Inventory;
